var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"detalhes-template-container"},_vm._l((_vm.dataTemplateAPR),function(dataRisco,index){return _c('detalhesTemplateItem',{key:index,attrs:{"dataRisco":dataRisco}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2644d0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/apr/templateApr/components/detalhesTemplate/detalhesTemplate.vue
// module id = null
// module chunks = 